import * as React from "react";
import { injectIntl, InjectedIntlProps } from "react-intl";
import moment from "moment";
import {Table, message, Pagination} from "antd";
import { consoleApi } from "src/apiMiddleware";
import empty from "../../../assets/image/empty.svg";
import "./LogSearchDetail.less";
import {IReactionDisposer, reaction} from "mobx";
import {logStore} from "../../../models/LogStore";
import {LoadingOutlined} from "@ant-design/icons/lib";

export type ConnectDetailProps = {
    uuid: string,
    startTime: string,
} & InjectedIntlProps;
export type LogType = {
    key: string,
    ip: string,
    time: string,
    akkoVersion: string,
    level: string,
    message: string,
    os: string,
    platform: string,
    sdkVersion: string,
    userId: string,
    uuid: string,
};

export type ConnectDetailStates = {
    logArray: LogType[],
    isLoading: boolean,
    isMaskLoading: boolean,
    page: number,
    count: number,
};

class ConnectDetail extends React.Component<ConnectDetailProps, ConnectDetailStates> {
    private readonly reactionDateDisposer: IReactionDisposer;
    public constructor(props: ConnectDetailProps) {
        super(props);
        this.reactionDateDisposer = this.startDateReaction();
        this.state = {
            logArray: [],
            isLoading: false,
            isMaskLoading: false,
            page: 1,
            count: 0,
        };
    }
    private startDateReaction(): IReactionDisposer {
        return reaction(() => {
            return logStore.selectedDate;
        }, async date => {
            await this.getLogDataByPage(1, date);
        });
    }
    public async componentDidMount(): Promise<void> {
        await this.getLogDataByPage(1);
    }

    private getLogDataByPage = async (page: number, date?: any): Promise<void> => {
        const {uuid, startTime} = this.props;
        let endDay;
        let startDay;
        if (date) {
            startDay = moment(date).startOf("day").valueOf();
            endDay = moment().valueOf();
        } else {
            startDay = moment(parseInt(startTime)).startOf("day").valueOf();
            endDay = moment().valueOf();
        }
        try {
            this.setState({ isMaskLoading: true });
            const res = await consoleApi.data.getLogDataByUuid(uuid, startDay, endDay, page);
            if (res.data.logs) {
                const array = res.data.logs.map((data: any, index: number) => {
                    const time = parseInt(data["__tag__:__receive_time__"]) * 1000;
                    return {
                        key: `log${index}`,
                        ip: data["__tag__:__client_ip__"],
                        time: `${moment(time).format("l")} - ${moment(time).format("LTS")}`,
                        level: data["level"],
                        message: data["message"],
                        os: data["os"],
                        platform: data["platform"],
                        sdkVersion: data["sdkVersion"],
                        userId: data["userId"],
                    };
                });
                if (res.data.logs.length === 0) {
                    message.warn("No log information during this period");
                }
                this.setState({ logArray: array, isMaskLoading: false, count: res.data.count});
            }
        } catch (error) {
            message.error(`error message: ${error}`);
            this.setState({ isMaskLoading: false });
        }
    }
    private renderRoomTable(): React.ReactNode {
        const { logArray } = this.state;
        if (logArray && logArray.length > 0) {
            const columns = [
                {
                    title: "IP",
                    dataIndex: "ip",
                    key: "ip",
                },
                {
                    title: "Time",
                    dataIndex: "time",
                    key: "time",
                },
                {
                    title: "Level",
                    dataIndex: "level",
                    key: "level",
                },
                {
                    title: "Message",
                    dataIndex: "message",
                    key: "message",
                },
                {
                    title: "OS",
                    dataIndex: "os",
                    key: "os",
                },
                {
                    title: "Platform",
                    dataIndex: "platform",
                    key: "platform",
                },
                {
                    title: "SdkVersion",
                    dataIndex: "sdkVersion",
                    key: "sdkVersion",
                },
                {
                    title: "UserId",
                    dataIndex: "userId",
                    key: "userId",
                },
            ];
            return (
                <div className="user-table-box">
                    <Table
                        bordered
                        pagination={false}
                        style={{ width: "100%", fontSize: 12}}
                        columns={columns}
                        dataSource={logArray} />
                    <Pagination
                        style={{marginTop: 16}}
                        defaultCurrent={this.state.page}
                        total={this.state.count}
                        onChange={this.handlePagination}/>
                </div>
            );
        } else {
            return <img src={empty} alt="empty"/>;
        }
    }
    private handlePagination = async (data: any): Promise<void> => {
        await this.getLogDataByPage(data);
    }

    private renderMask = (): React.ReactNode => {
        if (this.state.isMaskLoading) {
            return (
                <div className="content-box-mask">
                    <LoadingOutlined
                        style={{fontSize: 36, color: "#3381FF"}} />
                </div>
            );
        } else {
            return null;
        }
    }

    public render(): React.ReactNode {
        return (
            <div key={"body"} className="product-center-box">
                <div className="portal-room-outbox">
                    <div className="portal-room-chart">
                        <div className="portal-room-box-mid">
                            {this.renderMask()}
                            <div className="console-content-chart-body">
                                <div className="console-content-chart-box">
                                    <div style={{ minHeight: 420 }}
                                         className="console-content-chart-box-inner">
                                        {this.renderRoomTable()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default injectIntl(ConnectDetail);



// WEBPACK FOOTER //
// ./src/components/portal/logSearch/ConnectDetail.tsx